import axios from '../../axios';

const service = {
  fetchMatingEventTypes() {
    return axios({ method: 'get', url: '/breeding/mating-event-types' });
  }
};

export default service;
